import {flickityLib} from '../lazy_modules';

class BgVideoSlider implements ng.IComponentController {
    slides: anm.BgVideoSlide[];

    private start    = false;
    private showNext = false;
    readonly flicktyPromise: ng.IPromise<any>;

    constructor(private $element: ng.IAugmentedJQuery,
                private $q: ng.IQService) {
        this.flicktyPromise = $q(resolve => loadScripts([flickityLib], resolve));
        setTimeout(() => this.showNext = true, 3000);
    }

    $postLink() {
        this.initFlickty('.vm-product-item', true, false);
    }

    showVideo(index: number) {
        return this.start && (index === 0 || this.showNext);
    }

    handlerVideoLoaded() {
        this.showNext = true;
    }

    private initFlickty(cellSelector: string, prevNextButtons: boolean, pageDots: boolean) {
        this.flicktyPromise.then(() => {
            const Flickity = window.Flickity;
            new Flickity(this.$element[0].firstChild, {
                cellSelector,
                prevNextButtons,
                pageDots,
                wrapAround: true,
                resize: false,
                cellAlign: 'center',
                adaptiveHeight: true,
                setGallerySize: false
            });
            this.start = true;
        });
    }
}

angular.module('animatronApp.bgVideoSlider', []).component('bgVideoSlider', {
    bindings: {
        slides: '<'
    },
    controller: BgVideoSlider,
    templateUrl: require('bg-video-slider.html')
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/bgVideoSlider.ts